/*
 * @Author: zuishuanicx 1342142818@qq.com
 * @Date: 2022-03-16 14:48:52
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-03-20 14:31:01
 * @FilePath: \dzCloud\src\projects\tiktok\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import scroll from 'vue-seamless-scroll';
import { baseType } from '@tiktok/config/index';
import 'saas-common-service/lib/saas-common-service.css';
import 'daze-cloud-components/lib/daze-cloud-components.css';
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import './plugins/axios.js';
import '../../plugins/filters.js';
import '../../common/util.js';
import '../../common/config.js';
import '../../plugins/mixin.js';

import './assets/styles/reset.scss';
import('./assets/styles/' + (baseType === 'PUTI' ? 'common-puti' : 'common') + '.scss');

import VueClipBoard from 'vue-clipboard2';
Vue.use(scroll);
Vue.use(Element);
Vue.use(VueClipBoard);
//如果是菩提的话 重写windowOPEN的方法
if (process.env.DZ_TYPE === 'PUTI') {
    window.open = (function (nativeOpen) {
        return function (url, windowName, windowFetures) {
            if (url === 'http://occ.fjdaze.com/auth/login?appkey=6840999917110199815') {
                url = 'http://occ.fjdaze.com/auth/login?appkey=7225886893387286020';
            }
            if (url.includes('https://fuwu.jinritemai.com/detail?service_id=97')) {
                url =
                    'https://fuwu.jinritemai.com/detail?btm_ppre=a0254.b7465.c55193&btm_pre=a0254.b9825.c7579.d6976_31&page_from=1g2ocl4i1_b9825&pre_show_id=ec785203-3c6b-4d11-aa9a-258b83f61019&searchKey=&service_id=25314';
            }
            return nativeOpen(url, windowName, windowFetures);
        };
    })(window.open);
}

import { plugins } from 'saas-common-service';
const {
    directives: { onlyNum },
} = plugins;

Vue.use(onlyNum);

Vue.config.productionTip = false;

const Bus = new Vue();
Vue.prototype.$bus = Bus;

const vue = new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
export default vue;
